import { render, staticRenderFns } from "./ArticleThumb.vue?vue&type=template&id=33584a3a&scoped=true"
import script from "./ArticleThumb.vue?vue&type=script&lang=js"
export * from "./ArticleThumb.vue?vue&type=script&lang=js"
import style0 from "./ArticleThumb.vue?vue&type=style&index=0&id=33584a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33584a3a",
  null
  
)

export default component.exports